import { render, staticRenderFns } from "./ClientsWidget.vue?vue&type=template&id=ae7d132c&"
import script from "./ClientsWidget.vue?vue&type=script&lang=js&"
export * from "./ClientsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports